import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { trackPWAInstall, trackPWAInstallationConfirmed } from './utils/gtag';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Defer web-vitals to idle to avoid blocking main thread during initial load
const requestIdle = (cb) => {
  if (typeof window !== 'undefined') {
    const ric = window.requestIdleCallback || ((fn) => setTimeout(() => fn({ timeRemaining: () => 50, didTimeout: false }), 1));
    ric(cb);
  }
};

requestIdle(() => {
  import('./reportWebVitals').then(({ default: reportWebVitals }) => {
    try {
      reportWebVitals();
    } catch (_) {}
  });
});

// Check for PWA installation status on app load (iOS fallback)
const checkPWAInstallation = () => {
  // Check if app is running in standalone mode (installed)
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches || 
                      (window.navigator.standalone === true);
  
  if (isStandalone) {
    // Check if we've already tracked this installation
    const hasTrackedInstall = localStorage.getItem('pwa_install_tracked');
    
    if (!hasTrackedInstall) {
      // Track successful installation (iOS and other browsers fallback)
      trackPWAInstall('installed', 'standalone_detection');
      trackPWAInstallationConfirmed('standalone_detection');
      localStorage.setItem('pwa_install_tracked', 'true');
      console.log('✅ PWA installation detected and tracked (standalone mode)');
    }
  }
};

// Check PWA installation status when app loads
if (typeof window !== 'undefined') {
  // Run immediately
  checkPWAInstallation();
  
  // Also run after a short delay to ensure all checks are complete
  setTimeout(checkPWAInstallation, 1000);
}

// Register service worker for performance optimization (skip on localhost to avoid dev-server conflicts)
const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

if ('serviceWorker' in navigator && !isLocalhost) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        let isRefreshing = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (isRefreshing) return;
          isRefreshing = true;
          window.location.reload();
        });

        // Check for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // Auto-activate new worker and refresh once to avoid stale bundles
              newWorker.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
      })
      .catch((registrationError) => {
        // Silent error handling
      });
  });
}
